module.exports = __webpack_public_path__ + "img/play_store.6a1d84ff.png";